import React from "react";
import { SpecialPointsContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Cards, Headers, Navigations } from "components";

class SpecialPointsContainer extends React.Component {
  handleClickMenu = (e) => {
    this.props.router.navigate(e.path);
  };

  render() {
    const { data, t } = this.props;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Survey", { ns: "common" }),
      },
    ];
    return (
      <SpecialPointsContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="special_points_container">
          <div className="header_sec">
            <Headers.NewPageHeader
              title={"SPECIAL GIFT"}
              sub_title={"ของรางวัลพิเศษ"}
            />
          </div>
          <div className="special_points_layout">
            <Cards.MusicPracticeRoom
              description_en="M2 Grand Piano Detail M2 Grand Piano Detail M2 Grand Piano Detail M2 Grand Piano Detail M2 Grand Piano Detail M2 Grand Piano Detail M2 Grand Piano Detail M2 Grand Piano DetailM2 Grand Piano Detail M2 Grand Piano Detail M2 Grand Piano Detail"
              description_th="ของรางวัลพิเศษ"
            />
          </div>

          {data &&
            data.map((e, i) => (
              <div
                key={i}
                className="menu_item_wrap"
                onClick={() => this.handleClickMenu(e)}
              >
                <Cards.MenuItem
                  icon={e.icon}
                  name={t(e.name, { ns: "common" })}
                />
              </div>
            ))}
        </div>
      </SpecialPointsContainerStyled>
    );
  }
}

export default withTranslation(["common"])(withRouter(SpecialPointsContainer));
